import React, { useEffect, useState } from "react";
import axios from "axios";

function TimeOrder() {
  const [readyOrders, setReadyOrders] = useState([]);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get("/api/Product/getAllProducts");
        setProducts(response.data);
      } catch (error) {
        console.error("Erreur lors du chargement des produits :", error);
      }
    };

    fetchProducts();
  }, []);

  useEffect(() => {
    const fetchReadyOrders = async () => {
      try {
        const response = await axios.get("/api/ReadyOrders/getAllReadyOrders");
        setReadyOrders(response.data);
      } catch (error) {
        console.error("Erreur lors du chargement des commandes prêtes :", error);
      }
    };

    fetchReadyOrders();
  }, []);

  const handleArchiveOrder = async (orderId) => {
    try {
      const orderToArchive = readyOrders.find(order => order._id === orderId);

      const confirmationDate = new Date(orderToArchive.confirmationDate);
      const readyTime = new Date(); // Utiliser l'heure actuelle pour readyTime

      const newOrder = {
        orderId: orderToArchive.orderId,
        tableNumber: orderToArchive.tableNumber,
        items: orderToArchive.items,
        confirmationDate: orderToArchive.confirmationDate, // Conserver la date de confirmation d'origine
        readyTime: readyTime.toISOString(), // Utiliser l'heure actuelle
        waitingTime: new Date().toISOString(), // Optionnel : vous pouvez supprimer ce champ si inutile
        isReady: true,
      };

      await axios.post("/api/ReadyOrders/archiveReadyOrder", newOrder);
      alert("Commande archivée !");
    } catch (error) {
      console.error("Erreur lors de l'archivage de la commande :", error);
    }
  };

  const handleDeleteReadyOrder = async (orderId) => {
    try {
      await axios.delete(`/api/ReadyOrders/deleteReadyOrder/${orderId}`);
      setReadyOrders((prevOrders) => prevOrders.filter(order => order._id !== orderId));
      alert("Commande prête supprimée !");
    } catch (error) {
      console.error("Erreur lors de la suppression de la commande prête :", error);
      alert("Erreur lors de la suppression de la commande prête.");
    }
  };

  // Fonction pour formater l'heure de confirmation
  const formatConfirmationDate = (date) => {
    if (!date) return "N/A"; // Si la date est null ou undefined, retourner "N/A"
    const parsedDate = new Date(date);
    return parsedDate.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  };

  // Calculer le temps de préparation
  const calculatePreparationTime = (confirmationDate, readyTime) => {
    if (!confirmationDate || !readyTime) return "N/A";

    const confirmation = new Date(confirmationDate);
    const ready = new Date(readyTime);

    if (isNaN(confirmation.getTime()) || isNaN(ready.getTime())) {
        console.error("Dates invalides :", confirmationDate, readyTime);
        return "N/A";
    }

    const differenceInMilliseconds = ready - confirmation;
    if (differenceInMilliseconds < 0) {
        console.error("Erreur : readyTime est avant confirmationDate");
        return "N/A";
    }

    // 🔄 Utilisation de Math.ceil() au lieu de Math.round()
    const totalMinutes = Math.ceil(differenceInMilliseconds / (1000 * 60));
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
};


  return (
    <div className="time-order-container">
      <h2>Tableau des commandes prêtes</h2>
      <table className="order-table">
        <thead>
          <tr>
            <th>Numéro de commande</th>
            <th>Numéro de table</th>
            <th>Nature de la commande</th>
            <th>Heure de confirmation</th>
            <th>Heure prête</th>
            <th>Temps de préparation</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {readyOrders.map((order) => (
            <tr key={order._id}>
              <td>{order.orderId}</td>
              <td>{order.tableNumber}</td>
              <td>
                <ul>
                  {order.items.map((item, idx) => (
                    <li key={idx}>
                      {item.name} x {item.quantity}
                    </li>
                  ))}
                </ul>
              </td>
              <td>
                {order.confirmationDate
                  ? new Date(order.confirmationDate).toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    })
                  : "N/A"}
              </td>
              <td>
                {order.readyTime
                  ? new Date(order.readyTime).toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    })
                  : "N/A"}
              </td>
              <td>
                {calculatePreparationTime(order.confirmationDate, order.readyTime)}
              </td>
              <td>
                <button onClick={() => handleArchiveOrder(order._id)}>Archiver</button>
                <button onClick={() => handleDeleteReadyOrder(order._id)}>Supprimer</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default TimeOrder;